import React from 'react';
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl';
export function isI18n(i18n) {
  return isI18nString(i18n) || isI18nObject(i18n);
}
export function isI18nString(i18n) {
  return typeof i18n === 'string';
}
export function isI18nObject(i18n) {
  return typeof i18n === 'object' && i18n != null && !!i18n.id;
}
export function formatI18n(intl, i18n) {
  if (isI18nString(i18n)) {
    return intl.formatMessage({
      id: i18n
    });
  } else if (isI18nObject(i18n)) {
    var id = i18n.id,
      values = i18n.values;
    return intl.formatMessage({
      id: id
    },
    // ignoring because the @types definition is incorrect, and values can have ReactElements
    // @ts-ignore
    values);
  } else {
    console.warn("Problem in `formatI18n`: supplied i18n prop of type ".concat(typeof i18n, ", `string` or `object` required."));
    return '';
  }
}
function getEscapedValue(i18n, escape) {
  if (isI18nString(i18n)) {
    return escape;
  } else if (isI18nObject(i18n)) {
    return typeof i18n.escape === 'undefined' ? escape : i18n.escape;
  } else {
    console.warn("Problem in `i18n/getEscapedValue`: supplied i18n prop of type ".concat(typeof i18n, ", `string` or `object` required."));
    return true;
  }
}
export default function I18n(_ref) {
  var i18n = _ref.i18n,
    _ref$escape = _ref.escape,
    escape = _ref$escape === void 0 ? true : _ref$escape;
  var isEscaped = getEscapedValue(i18n, escape);
  var Component = isEscaped ? FormattedMessage : FormattedHTMLMessage;
  var extraProps = isEscaped ? undefined : {
    tagName: 'span'
  };
  if (isI18nString(i18n)) {
    return /*#__PURE__*/React.createElement(Component, Object.assign({
      id: i18n
    }, extraProps));
  } else if (isI18nObject(i18n)) {
    return /*#__PURE__*/React.createElement(Component, Object.assign({}, i18n, extraProps));
  } else {
    console.warn("Problem in `I18n`: supplied i18n prop of type ".concat(typeof i18n, ", `string` or `object` required."));
    return null;
  }
}